<template>
  <div>
    <div class="px-5">
      <div class="text-h4 font-weight-black">FAQ</div>
      <div style="font-size: 10px">Last updated: April 15, 2021</div>
    </div>
    <div class="px-5">
      <v-expansion-panels>
        <v-expansion-panel class="panel-accordion mt-5">
          <v-expansion-panel-header class="panel-accordion font-weight-black">
            Bagaimana cara memesan layanan di Teman Bakat?
          </v-expansion-panel-header>
          <v-expansion-panel-content class="py-5" style="font-size: 12px">
            <p class="font-weight-black mt-5"></p>
            1. Mengunduh aplikasi Teman Bakat <br />
            2. Masuk ke aplikasi dan ikuti misi yang disediakan <br />
            3. Membuat akun Teman Bakat dan masuk dengan akun tersebut<br />
            4. Pilih layanan yang tersedia di beranda sesuai kebutuhan<br />
            5. Jika sudah memilih pesanan, silakan tekan tombol tambah ke
            “Keranjang” <br />
            6. Bayar pesanan tersebut menggunakan poin yang dimiliki<br />
            7. Jika poin Anda cukup, Anda akan mendapat pesan konfirmasi dan
            dialihkan ke menu “My Order”<br />
            8. Anda dapat melihat seluruh transaksi layanan yang Anda buat pada
            menu tersebut<br />
            9. Sementara itu, jika poin Anda tidak cukup maka akan muncul
            pemberitahuan. Silakan membeli poin pada aplikasi untuk dapat
            memesan layanan di Teman Bakat<br />
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel class="panel-accordion mt-5">
          <v-expansion-panel-header class="panel-accordion font-weight-black">
            Bagaimana cara melakukan transaksi di Teman Bakat?
          </v-expansion-panel-header>
          <v-expansion-panel-content class="py-5" style="font-size: 12px">
            1. Seluruh transaksi layanan di Teman Bakat dilakukan menggunakan
            poin <br />
            2. Bila poin tidak cukup, Anda dapat membelinya dengan menekan
            tombol poin yang ada di beranda <br />
            3. Pada tombol tersebut tersedia berbagai macam paket poin, pilihlah
            paket yang Anda inginkan <br />
            4. Pilih metode pembayaran untuk membeli paket poin yang telah
            dipilih, yaitu dengan transfer bank BCA, dan BRI. Selain itu
            tersedia juga pembayaran melalui OVO, DANA, ShopeePay, Gopay, dan
            LinkAja <br />
            5. Jika sudah melakukan pembayaran, silakan unggah bukti pembayaran
            dalam jangka waktu 2 x 24 jam <br />
            6. Bukti pembayaran akan kami verifikasi dalam jangka waktu 2 jam
            pada jam kerja (09.00 – 18.00 WIB) <br />
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel class="panel-accordion mt-5">
          <v-expansion-panel-header class="panel-accordion font-weight-black">
            Apa yang harus saya lakukan jika saya tidak bisa melakukan
            registrasi akun?
          </v-expansion-panel-header>
          <v-expansion-panel-content class="py-5" style="font-size: 12px">
            Silakan periksa kembali nomor handphone, e-mail, dan kesesuaian kata
            sandi yang Anda buat. Pastikan bahwa ketiga hal tersebut sudah
            benar. Mohon diperhatikan bahwa nomor handphone dan alamat e-mail
            hanya dapat digunakan satu kali dalam pembuatan satu akun
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel class="panel-accordion mt-5">
          <v-expansion-panel-header class="panel-accordion font-weight-black">
            Saya tidak dapat sign in, apa yang harus saya lakukan?
          </v-expansion-panel-header>
          <v-expansion-panel-content class="py-5" style="font-size: 12px">
            Cobalah periksa kembali e-mail dan kata sandi yang Anda masukkan.
            Pastikan sudah sesuai dengan yang terdaftar pada akun Teman Bakat.
            Apabila masih terdapat kendala, silakan hubungi nomor 0895343884140
            melalui whatsapp.
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel class="panel-accordion mt-5">
          <v-expansion-panel-header class="panel-accordion font-weight-black">
            Berapa lama saya harus menunggu hasil psikotes?
          </v-expansion-panel-header>
          <v-expansion-panel-content class="py-5" style="font-size: 12px">
            Hasil psikotes dapat langsung diterima setelah Anda menyelesaikan
            psikotes tersebut. Namun khusus untuk psikotes Penjurusan Kuliah &
            SMA, hasilnya akan diberikan dalam jangka waktu 2 x 24 jam pada jam
            kerja setelah psikotes selesai. Oleh karena itu apabila psikotes
            tersebut dilaksanakan pada hari Sabtu, maka hasil akan diberikan
            pada hari Selasa. Silakan periksa e-mail dan akun pada aplikasi
            teman bakat untuk memeriksa hasil psikotes.
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel class="panel-accordion mt-5">
          <v-expansion-panel-header class="panel-accordion font-weight-black">
            Apa yang harus dilakukan jika saya terlambat memulai psikotes?
          </v-expansion-panel-header>
          <v-expansion-panel-content class="py-5" style="font-size: 12px">
            Psikotes yang telah Anda pesan memiliki masa aktif yaitu 2 x 24 jam
            setelah pembayaran. Sesuai dengan peraturan yang ada, apabila Anda
            terlambat dan tidak mengikuti psikotes dalam jangka waktu tersebut
            maka Anda dianggap mengundurkan diri dan poin tidak akan kembali ke
            akun Anda. Namun Anda tetap dapat kembali memesan layanan psikotes
            yang baru dan melakukan pembayaran ulang.
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel class="panel-accordion mt-5">
          <v-expansion-panel-header class="panel-accordion font-weight-black">
            Apabila pada pertengahan psikotes terdapat kendala teknis pada
            device saya, Apa yang harus saya lakukan? Apakah saya harus
            mengulang tesnya?
          </v-expansion-panel-header>
          <v-expansion-panel-content class="py-5" style="font-size: 12px">
            Anda memiliki kesempatan untuk mengulang psikotes selama dua kali.
            Apabila device yang digunakan tiba-tiba bermasalah, Anda dapat
            keluar dari aplikasi lalu masuk kembali ke menu “My Order”. Setelah
            itu Anda dapat memulai kembali psikotes tersebut dari awal
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel class="panel-accordion mt-5">
          <v-expansion-panel-header class="panel-accordion font-weight-black">
            Apakah saya bisa memesan layanan lain jika saya belum menyelesaikan
            psikotes yang saya pesan?
          </v-expansion-panel-header>
          <v-expansion-panel-content class="py-5" style="font-size: 12px">
            Tidak. Anda harus menyelesaikan psikotes yang sudah dipesan terlebih
            dahulu, baru Anda bisa melakukan transaksi lain.
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel class="panel-accordion mt-5">
          <v-expansion-panel-header class="panel-accordion font-weight-black">
            Apakah bisa apabila saya sudah memesan layanan konseling, namun
            ingin mengikuti psikotes setelahnya?
          </v-expansion-panel-header>
          <v-expansion-panel-content class="py-5" style="font-size: 12px">
            Kami memiliki layanan konseling dan psikotes, sehingga bila Anda
            ingin menambah layanan Anda hanya perlu memesan layanan tersebut dan
            membayar sesuai prosedur.
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel class="panel-accordion mt-5">
          <v-expansion-panel-header class="panel-accordion font-weight-black">
            Apakah saya bisa membatalkan pesanan yang telah dibayarkan?
          </v-expansion-panel-header>
          <v-expansion-panel-content class="py-5" style="font-size: 12px">
            Pesanan yang telah dibayar tidak dapat dibatalkan. Kecuali apabila
            pesanan tersebut belum dibayar, Anda dapat membatalkannya dengan
            membiarkannya pada keranjang atau menghapus pesanan tersebut
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel class="panel-accordion mt-5">
          <v-expansion-panel-header class="panel-accordion font-weight-black">
            Apakah saya bisa berganti layanan dari paket A ke paket B?
          </v-expansion-panel-header>
          <v-expansion-panel-content class="py-5" style="font-size: 12px">
            Apabila Anda telah melakukan pembayaran, maka Anda tidak dapat
            mengubah layanan yang telah dipilih. Silakan Anda memesan dan
            membayar ulang paket lainnya.
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel class="panel-accordion mt-5">
          <v-expansion-panel-header class="panel-accordion font-weight-black">
            Kapan saya bisa memulai konseling?
          </v-expansion-panel-header>
          <v-expansion-panel-content class="py-5" style="font-size: 12px">
            Konseling dapat dimulai sesuai dengan jadwal yang telah Anda
            tentukan. Setelah memesan dan membayar layanan konseling, Anda akan
            diminta untuk mengatur jadwal konseling sesuai dengan keinginan
            Anda. Sementara itu apabila Anda memesan paket layanan psikotes dan
            konseling, maka setelah hasil psikotes diterima Anda baru dapat
            menentukan jadwal konseling. Mohon untuk mengingat dan meluangkan
            waktu pada jadwal yang telah dipilih, agar Anda tidak melewatkan
            waktu konseling.
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel class="panel-accordion mt-5">
          <v-expansion-panel-header class="panel-accordion font-weight-black">
            Apabila selama konsultasi saya mengalami kendala internet sehingga
            waktu yang tersedia tidak terpakai secara maksimal, adakah
            perpanjangan waktu?
          </v-expansion-panel-header>
          <v-expansion-panel-content class="py-5" style="font-size: 12px">
            Kami tidak memberikan perpanjangan waktu apabila terdapat kendala
            sinyal. Oleh karena itu usahakan device dan internet dapat menunjang
            jalannya konsultasi dan juga psikotes.
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
  </div>
</template>
<script>
export default {
  name: "Faq",
};
</script>
<style scoped>
.panel-accordion {
  background-color: #e5e5e5;
}
</style>
